module.exports = __webpack_public_path__ + "img/67e2050.svg";